export const TRANSLATION_KEYS = {
	SEARCH_LOCATION: 'searchLocation',
	SEARCH_LOCATION_FILTERS: 'searchLocation.filters',
	PROVIDER_DETAILS: 'providerDetails',
	DIALOG: 'dialog',
	COMMONS: 'commons',
	CLAIMS: 'claims',
	OONCLAIMS: 'oonClaims',
	SPECIAL_OFFERS: 'specialOffers',
	PRESCRIPTIONS: 'prescriptions',
	MY_BENEFITS: 'myBenefits',
	MY_PROFILE: 'myProfile',
	DB_LABELS: 'dbLabels',
	ERRORS: 'errors',
	CLIENT_LABELS: 'clientLabels',
	CLIENT_LABELS_INDEX: 'clientLabels.Index',
	UPLOAD_FILE_DIALOG: 'uploadFileDialog',
	INDEX: 'Index',
	CONTACT_US: 'contactUs',
	KNOW_BEFORE_YOU_GO: 'knowBeforeYouGo',
	SERVICE: 'service',
};

export const INVALID_DATE = 'Invalid Date';

export const SERVICES_SHORT_TRANSLATION_KEY = 'short';
// for the moment we have special needs only on 'others'
export enum SERVICES_GROUPS {
	OTHERS = 'others',
}

export enum RESET_SELECTED_ROUTES {
	VIEW_CLAIMS = '/view-claims',
	VIEW_PAYMENT_HISTORY = '/view-payment-history',
	CLAIMS_NOTIFICATIONS = '/claims-notifications',
}

export const TEMP_SERVICES = [
	{
		code: 'exam',
		label: 'service.exam',
		group: {
			code: '',
			label: '',
		},
	},
	{
		code: 'lens',
		label: 'service.lens',
		group: {
			code: '',
			label: '',
		},
	},
	{
		code: 'frame',
		label: 'service.frame',
		group: {
			code: '',
			label: '',
		},
	},
	{
		code: 'contacts',
		label: 'service.contacts',
		group: {
			code: '',
			label: '',
		},
	},
	{
		code: 'fitting',
		label: 'service.fitting',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'warranty',
		label: 'service.warranty',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'second-pair',
		label: 'service.second-pair',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'cleaning-kit',
		label: 'service.cleaning-kit',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'generic',
		label: 'service.generic',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'vat',
		label: 'service.vat',
		group: {
			code: 'others',
			label: 'service_group.others',
		},
	},
	{
		code: 'monofocal-lens',
		label: 'service.monofocal-lens',
		group: {
			code: 'eyewear',
			label: 'service_group.eyewear',
		},
	},
	{
		code: 'bifocal-lens',
		label: 'service.bifocal-lens',
		group: {
			code: 'eyewear',
			label: 'service_group.eyewear',
		},
	},
	{
		code: 'trifocal-lens',
		label: 'service.trifocal-lens',
		group: {
			code: 'eyewear',
			label: 'service_group.eyewear',
		},
	},
	{
		code: 'progressive-lens',
		label: 'service.progressive-lens',
		group: {
			code: 'eyewear',
			label: 'service_group.eyewear',
		},
	},
];

export const INVOICE_NUMBER_MAX_LENGTH = 128;

export const PATHNAMES = {
	HOME: '/',
	CHECK_AND_SUBMIT: 'check-and-submit',
	NEW_CLAIM: 'new-claim',
	VIEW_CLAIMS: 'view-claims',
	LOCATION_INFORMATION: 'location-information',
	VIEW_PAYMENT_HISTORY: 'view-payment-history',
	EXPLANATION_OF_PAYMENT: 'explanation-of-payment',
	GROUP_INVOICE_ASSESSMENT: 'group-invoice-assessment',
	ASSESSMENT_FEE_INVOICE: 'assessment-fee-invoice',
	DOCUMENTATION: 'documentation',
	CONTACT_US: 'contact-us',
	CLAIMS_NOTIFICATIONS: 'claims-notifications',
};

export const CLAIM_NOTE_MAX_LENGTH = 250;

export const NOTIFICATIONS_EXPIRY_DAYS = 30;
